// extracted by mini-css-extract-plugin
module.exports = {"ReminderScreenRoot":"ReminderScreen_ReminderScreenRoot__Op0L4","Headings":"ReminderScreen_Headings__3r5sM","inputText":"ReminderScreen_inputText__1HGGk"};